import React from 'react';
import Link from 'next/link';

interface DropdownMenuProps {
  open: boolean;
  onClose: () => void;
  pathname: string;
  menuItems?: { label: string; href: string }[];
}

const defaultMenuItems = [
  { label: 'Default', href: '/' },
];

export default function DropdownMenu({ open, onClose, pathname, menuItems }: DropdownMenuProps) {
  if (!open) return null;
  return (
    <div className="absolute right-0 mt-2 w-52 max-w-64 rounded-xl shadow-lg bg-white ring-1 ring-black/5 z-50">
      <div className="relative">
        {/* Arrow */}
        <div className="absolute top-0 right-5 w-6 h-6 bg-white rounded-md rotate-45 -mt-2 z-[-1]" />
        {/* Menu items */}
        <ul className="py-4 px-4 text-black text-[16px] font-medium">
          {(menuItems || defaultMenuItems).map((item) => (
            <li key={item.href} className="cursor-pointer px-4 py-2 hover:text-orange">
              <Link
                onClick={onClose}
                className={pathname === item.href ? 'text-orange' : ''}
                href={item.href}
                prefetch={false}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
